import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { ellipseWeight, visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyPlateau(heights, resolution, layoutSize, feature, noise) {
    const terraces = Math.max(1, feature.params?.terraces ?? 3);
    const strength = feature.strength ?? 1;
    const top = feature.height;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const weight = ellipseWeight(u, v, noise, feature.seed);
        if (weight <= 0) return;

        const stepped = Math.round(weight * terraces) / terraces;
        const current = heights[idx];
        const raised = current + (top - current) * stepped * strength;
        if (raised > current) writeHeight(heights, idx, clampHeight(raised));
    });
}
